import script from "./OrderSearch.vue?vue&type=script&setup=true&lang=js"
export * from "./OrderSearch.vue?vue&type=script&setup=true&lang=js"

import "./OrderSearch.vue?vue&type=style&index=0&id=5124d0a4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5124d0a4"]])

export default __exports__